import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import Education from "./Education";
import Experience from "./Experience";
import FadeIn from "../FadeIn";

function About() {
  return (
    <>
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <FadeIn direction="left">
                <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                  Know Who <strong className="purple">I'M</strong>
                </h1>
              </FadeIn>
              <FadeIn direction="left" delay={0.1}>
                <Aboutcard />
              </FadeIn>
            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <FadeIn direction="right">
                <img src={laptopImg} alt="about" className="img-fluid" />
              </FadeIn>
            </Col>
          </Row>
        </Container>
      </Container>
      <FadeIn direction="up">
        <Education />
      </FadeIn>
      <FadeIn direction="up">
        <Experience />
      </FadeIn>
      <Container fluid className="about-section">
        <Container>
          <FadeIn direction="up">
            <h1 className="project-heading">
              Professional <strong className="purple">Skillset </strong>
            </h1>
          </FadeIn>
          <FadeIn direction="up" delay={0.1}>
            <Techstack />
          </FadeIn>
          <FadeIn direction="up" delay={0.2}>
            <h1 className="project-heading">
              <strong className="purple">Tools</strong> I use
            </h1>
          </FadeIn>
          <FadeIn direction="up" delay={0.3}>
            <Toolstack />
          </FadeIn>
        </Container>
      </Container>
    </>
  );
}

export default About;